import { getVideoIframeUrl } from 'app/utilities/youtube';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Video content block component.
 * @param {Object} props - Component props.
 * @param {Object} props.data - Data for the video block.
 * @param {string} props.data.title - Title of the video.
 * @param {string} props.data.credit - Credit for the video.
 * @param {string} props.data.video_url - URL of the video.
 * @returns {JSX.Element} The rendered video block.
 */
function Video(props) {
    const { title, credit, video_url: videoUrl } = props.data;

    return (
        <section className="video-content-block">
            <div className="video-content-block-inner || constrain-width no-pad">
                <h3 className="section-header-title">{title}</h3>
                <div className="preserve-aspect-ratio">
                    <div className="preserve-aspect-ratio-media">
                        <iframe
                            title={title}
                            className="video"
                            src={getVideoIframeUrl(videoUrl)}
                            allowFullScreen={true}></iframe>
                    </div>
                </div>
                {credit && <p className="video-content-block-credit">{credit}</p>}
            </div>
        </section>
    );
}

Video.propTypes = {
    data: PropTypes.object.isRequired
};

export default Video;
